<template>
  <div class="">
    <div v-if="field.label">
      <template v-if="field.html">
        <div v-html="field.label"></div>
      </template>
      <template v-else>
        <p class="block text-argus-forest-600 text-sm whitespace-pre-wrap">{{ field.label }}</p>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    field: Object,
  },
  computed: {
    isValid() {
      return true
    },
  },
  data() {
    return {
      textEdit: false,
    }
  },
  methods: {
    toggleTextEdit() {
      if (this.field.editable === false) {
        return
      }
      this.textEdit = !this.textEdit
    },
    updateText(ev) {
      // eslint-disable-next-line vue/no-mutating-props
      this.field.label = ev.target.value
    },
  },
}
</script>
<style lang="scss" scoped></style>
